/* EYC vysouvací košík. Registruje <cart-drawer>, takže ho product-form.js použije po přidání do košíku. */
(function () {
  if (customElements.get('cart-drawer')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SECTIONS = 'eyc-cart-items,cart-icon-bubble';
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);

  class EycCartDrawer extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      /* Přesun pod <body>, aby zatmavení překrylo celou stránku. V editoru motivu ne. */
      if (!DESIGN && this.parentElement !== document.body) { document.body.appendChild(this); return; }
      this._init = true;
      this.panel = this.querySelector('.eycd__panel');

      this.addEventListener('click', (e) => {
        var t = e.target;
        var el;
        if ((el = t.closest('[data-eycd-close]'))) { e.preventDefault(); this.close(); return; }
        if ((el = t.closest('[data-eyc-qty]'))) { e.preventDefault(); this.change(el.dataset.key, parseInt(el.dataset.eycQty, 10)); return; }
        if ((el = t.closest('[data-eyc-add]'))) { e.preventDefault(); this.add(el.dataset.eycAdd, el); return; }
        if ((el = t.closest('[data-eycd-toggle]'))) { e.preventDefault(); this.togglePane(el.dataset.eycdToggle); return; }
        if ((el = t.closest('[data-eycd-remove-code]'))) { e.preventDefault(); this.removeCode(el.dataset.eycdRemoveCode); return; }
        if ((el = t.closest('[data-eycd-scroll]'))) {
          var track = el.closest('.eycd__rec').querySelector('.eycd__rec-track');
          track.scrollBy({ left: parseInt(el.dataset.eycdScroll, 10) * track.clientWidth * 0.8, behavior: 'smooth' });
        }
      });

      this.addEventListener('submit', (e) => {
        var f = e.target.closest('[data-eycd-discount]');
        if (f) {
          e.preventDefault();
          var code = (f.querySelector('input[name="code"]').value || '').trim();
          if (code) this.applyCode(code);
          return;
        }
        /* Před odchodem do pokladny počkej na uložení poznámky / volby Heureky */
        var co = e.target.closest('.eycd__checkout');
        if (co && this._pending) {
          e.preventDefault();
          var btn = co.querySelector('[name="checkout"]');
          if (btn) btn.disabled = true;
          this._pending.finally(function () {
            var hidden = document.createElement('input');
            hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = '1';
            co.appendChild(hidden);
            co.submit();
          });
        }
      });

      this.addEventListener('input', (e) => {
        if (!e.target.matches('[data-eycd-note]')) return;
        clearTimeout(this._nt);
        var val = e.target.value;
        var status = this.querySelector('[data-eycd-note-status]');
        if (status) status.textContent = '';
        this._nt = setTimeout(() => this.saveNote(val), 600);
      });

      this.addEventListener('change', (e) => {
        var cb = e.target.closest('[data-eycd-attr]');
        if (!cb) return;
        var attrs = {};
        attrs[cb.dataset.eycdAttr] = cb.checked ? (cb.dataset.eycdAttrValue || 'Ano') : '';
        this.track(this.request('cart/update.js', { attributes: attrs }, false))
          .catch(() => { cb.checked = !cb.checked; this.flash('Volbu se nepodařilo uložit, zkus to prosím znovu.'); });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trap(e);
      });

      /* Ikona košíku v hlavičce otevře košík místo přechodu na /cart */
      document.addEventListener('click', (e) => {
        var link = e.target.closest('#cart-icon-bubble, a.header__icon--cart, a[href="/cart"], a[href="' + ROOT + 'cart"]');
        if (!link || e.defaultPrevented) return;
        if (link.closest('cart-drawer')) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        var path = window.location.pathname.replace(/\/+$/, '');
        if (path.slice(-5) === '/cart') return;
        e.preventDefault();
        this.setActiveElement(link);
        this.open(true);
      });

      this.syncState();

      /* Přesměrování ze stránky /cart: ?cart=open otevře košík a parametr z adresy zmizí */
      try {
        var u = new URL(window.location.href);
        if (u.searchParams.get('cart') === 'open') {
          u.searchParams.delete('cart');
          var qs = u.searchParams.toString();
          window.history.replaceState(window.history.state, '', u.pathname + (qs ? '?' + qs : '') + u.hash);
          this.open(true);
        }
      } catch (_) {}
    }

    /* API, které volá product-form.js */
    getSectionsToRender() { return [{ id: 'eyc-cart-items' }, { id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsed) { this.apply(parsed && parsed.sections); this.open(false); }

    open(refresh) {
      if (this.classList.contains('is-open')) return;
      this.classList.add('is-open');
      document.documentElement.classList.add('eycd-lock');
      var x = this.querySelector('.eycd__x');
      setTimeout(function () { if (x) x.focus({ preventScroll: true }); }, 60);
      if (refresh) this.refresh();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('eycd-lock');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }

    trap(e) {
      var f = this.panel.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    togglePane(name, forceOpen) {
      var pane = this.querySelector('[data-eycd-pane="' + name + '"]');
      var btn = this.querySelector('[data-eycd-toggle="' + name + '"]');
      if (!pane) return;
      var open = forceOpen === true ? true : pane.hidden;
      pane.hidden = !open;
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var f = pane.querySelector('input, textarea'); if (f) f.focus({ preventScroll: true }); }
    }

    /* Sleduje rozpracované ukládání, aby pokladna počkala */
    track(p) {
      var all = Promise.all([this._pending || Promise.resolve(), p.catch(function () {})]);
      this._pending = all;
      all.finally(() => { if (this._pending === all) this._pending = null; });
      return p;
    }

    refresh() {
      return fetch(ROOT + '?sections=' + SECTIONS, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then((s) => this.apply(s))
        .catch(function () {});
    }

    request(url, body, render) {
      if (render !== false) { body.sections = SECTIONS; body.sections_url = window.location.pathname; }
      return fetch(ROOT + url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok && r.status >= 500) throw new Error(r.status); return r.json(); });
    }

    post(url, body) {
      this.classList.add('is-busy');
      return this.request(url, body)
        .then((d) => {
          if (d && d.status && (d.description || d.message)) { this.flash(d.description || d.message); return d; }
          this.apply(d && d.sections);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'eyc-cart-drawer', cartData: d }); } catch (_) {}
          }
          return d;
        })
        .catch(() => { this.flash('Něco se nepovedlo, zkus to prosím znovu.'); })
        .finally(() => this.classList.remove('is-busy'));
    }

    change(key, qty) { return this.post('cart/change.js', { id: key, quantity: Math.max(0, qty || 0) }); }

    add(id, btn) {
      if (btn) btn.classList.add('is-loading');
      return this.post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }

    currentCodes() {
      var list = this.querySelector('[data-eycd-codes]');
      return list && list.dataset.eycdCodes ? list.dataset.eycdCodes.split(',').filter(Boolean) : [];
    }

    applyCode(code) {
      var codes = this.currentCodes();
      if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) === -1) codes.push(code);
      this.post('cart/update.js', { discount: codes.join(',') }).then((d) => {
        if (!d || !d.discount_codes) return;
        var hit = d.discount_codes.filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
        if (hit && hit.applicable) return;
        var valid = d.discount_codes.filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        return this.post('cart/update.js', { discount: valid.join(',') }).then(() => {
          this.togglePane('discount', true);
          var input = this.querySelector('#EycCartCode');
          if (input) input.value = code;
          var err = this.querySelector('[data-eycd-code-err]');
          if (err) { err.textContent = 'Kód „' + code + '“ není platný nebo se na tvůj košík nevztahuje.'; err.hidden = false; }
        });
      });
    }

    removeCode(code) {
      var rest = this.currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      return this.post('cart/update.js', { discount: rest.join(',') });
    }

    saveNote(val) {
      var status = this.querySelector('[data-eycd-note-status]');
      this.track(this.request('cart/update.js', { note: val }, false))
        .then(function () { if (status) status.textContent = 'Poznámka uložena'; })
        .catch(function () { if (status) status.textContent = 'Poznámku se nepodařilo uložit'; });
    }

    apply(sections) {
      if (!sections) return;
      var html = sections['eyc-cart-items'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['head', 'lines', 'foot'].forEach((p) => {
          var src = doc.querySelector('[data-eycd-part="' + p + '"]');
          var dst = this.querySelector('[data-eycd-slot="' + p + '"]');
          if (src && dst) dst.innerHTML = src.innerHTML;
        });
        this.syncState();
        if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {
          try { window.Shopify.PaymentButton.init(); } catch (_) {}
        }
      }
      var b = sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      if (b && bubble) {
        var d2 = new DOMParser().parseFromString(b, 'text/html');
        var s = d2.querySelector('.shopify-section');
        bubble.innerHTML = (s || d2.body).innerHTML;
      }
    }

    syncState() {
      var meta = this.querySelector('[data-eycd-meta]');
      var n = meta ? parseInt(meta.dataset.count, 10) || 0 : 0;
      this.dataset.count = n;
      this.classList.toggle('is-empty', n === 0);
      this.updateShipping(meta);
    }

    updateShipping(meta) {
      var box = this.querySelector('[data-eycd-ship]');
      var th = parseFloat(this.dataset.threshold) || 0;
      if (!box) return;
      if (!meta || !th || meta.dataset.currency !== 'CZK') { box.hidden = true; return; }
      var total = (parseInt(meta.dataset.total, 10) || 0) / 100;
      var rest = Math.max(0, th - total);
      box.hidden = false;
      box.classList.toggle('is-done', rest === 0);
      box.querySelector('.eycd__ship-text').innerHTML = rest > 0
        ? 'Do dopravy zdarma ti chybí <strong>' + Math.ceil(rest).toLocaleString('cs-CZ') + ' Kč</strong>'
        : '<strong>Máš dopravu zdarma!</strong>';
      box.querySelector('.eycd__ship-bar span').style.width = Math.min(100, (total / th) * 100) + '%';
    }

    flash(msg) {
      var el = this.querySelector('.eycd__flash');
      if (!el) {
        el = document.createElement('p');
        el.className = 'eycd__flash';
        el.setAttribute('role', 'alert');
        this.querySelector('.eycd__head').after(el);
      }
      el.textContent = msg;
      clearTimeout(this._ft);
      this._ft = setTimeout(function () { el.remove(); }, 5000);
    }
  }

  customElements.define('cart-drawer', EycCartDrawer);

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var d = document.querySelector('cart-drawer');
    if (d && d.refresh) d.refresh();
  });
})();
